/**
 * Reemplazá estos datos por tus datos reales de contacto y garantía.
 */
export const guarantee = {
  days: 7,
};

export const store = {
  name: "Aura Content",
  tagline: "Productos digitales y recursos prácticos para aprender, organizarte y emprender.",
  email: "soporte.auracontent@gmail.com",
  year: 2026,
};

export const contact = {
  brand: "De tu cocina a tus primeros pedidos",
  tagline: "El plan paso a paso para quienes aman la repostería y quieren empezar a vender desde casa.",
  quote: "Porque lo que ya haces con amor también puede convertirse en tu emprendimiento.",
  email: "soporte.auracontent@gmail.com",
  instagram: "@detucocina",
  instagramUrl: "https://instagram.com/detucocina",
  website: "www.detucocina.com",
  websiteUrl: "https://www.detucocina.com",
};
